// extracted by mini-css-extract-plugin
export default {"opportunityPage":"OpportunityPage_opportunityPage__OfsVK","genderGrouping":"OpportunityPage_genderGrouping__Om6Mv"};